import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { DocumentTitle } from '@guildeducationinc/recess';
import { useAuth, Logout } from '@guildeducationinc/guild-auth';
import { datadogRum } from '@datadog/browser-rum';
import ErrorPage from '@shared/ErrorPage/ErrorPage';
import useEmployerService from '@src/hooks/useEmployerService';
import EditProfile from '@pages/EditProfile/EditProfile';
import Home from '../Pages/Home/Home';

const Routes: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.analytics) {
      window.analytics.page(); // tell segment what page we are on
    }
  }, [pathname]);

  const { loading, hasAuthError, user, authError } = useAuth();
  const { employer } = useEmployerService(user?.employerId);

  useEffect(() => {
    if (user) {
      if (window.analytics) {
        window.analytics.identify(user.id, {
          email: user.email,
          employerUuid: user.employerId,
          product: 'home',
        });
      }

      datadogRum.setUser({
        email: user.email,
        employerId: user.employerId,
        employerName: employer?.name,
        firstName: user.firstName,
        id: user.id,
        lastName: user.lastName,
      });
    }
    /* eslint-disable-next-line */
  }, [user]);

  if (!loading && hasAuthError) {
    return (
      <ErrorPage support={true} error={hasAuthError} authError={true} errorMessage={authError} />
    );
  }

  return (
    <Switch>
      <Route exact={true} path='/'>
        <DocumentTitle title='Home' />
        <Home />
      </Route>
      <Route exact={true} path='/user_edit'>
        <DocumentTitle title='Edit Profile' />
        <EditProfile />
      </Route>
      <Route exact={true} path='/logout' component={Logout} />
      <Route>
        <DocumentTitle title='Page not found' />
        <ErrorPage message='Page not found.' />
      </Route>
    </Switch>
  );
};

export default Routes;
